import { Phone } from "lucide-react";
import { CLINIC } from "@/lib/clinic";

export default function FloatingCall() {
  return (
    <a
      href={`tel:${CLINIC.phoneTel}`}
      data-testid="floating-call-btn"
      className="fixed bottom-[88px] left-5 right-auto z-[10000] sm:hidden inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-[#3A564A] hover:bg-[#2C4239] text-[#FAFAF9] text-sm font-semibold shadow-lg active:scale-95 transition-transform"
      aria-label="Call Dent Square"
    >
      <Phone className="w-4 h-4" /> Call Clinic
    </a>
  );
}
